import{__assign as r}from"../../../node_modules/tslib/tslib.es6.js";import{j as o}from"../../../node_modules/react/jsx-runtime.js";import{Box as e}from"@mui/material";var i=function(i){return o.jsx(e,r({},i,{children:i.children}))};export{i as Box};
//# sourceMappingURL=index.js.map
